module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header-section"
  }, [_c('div', {
    staticClass: "block-header-section__bg",
    style: (_vm.background)
  }, [_c('div', {
    staticClass: "block-header-section__container"
  }, [_c('div', {
    staticClass: "block-header-section__title-section",
    class: {
      "title-top": _vm.titlePosition === "vertical", "title-side": _vm.titlePosition === "lateral"
    }
  }, [_c('div', {
    staticClass: "block-header-section__title",
    class: {
      "title-left": _vm.titleAlign === "left", "title-right": _vm.titleAlign === "right", "title-center": _vm.titleAlign === "center"
    }
  }, [_vm._t("header", null, {
    "content": _vm.content.title
  })], 2), _c('div', {
    staticClass: "block-header-section__subtitle",
    class: {
      "title-left": _vm.titleAlign === "left", "title-right": _vm.titleAlign === "right", "title-center": _vm.titleAlign === "center"
    }
  }, [_vm._t("subheader", null, {
    "content": _vm.content.subtitle
  })], 2)]), _c('div', {
    staticClass: "block-header-section__body-section",
    class: {
      "body-bottom": _vm.titlePosition === "vertical", "body-side": _vm.titlePosition === "lateral"
    }
  }, [_c('div', {
    staticClass: "block-header-section__body",
    class: {
      "body-left": _vm.bodyAlign === "left", "body-right": _vm.bodyAlign === "right", "body-center": _vm.bodyAlign === "center"
    }
  }, [_vm._t("body", null, {
    "content": _vm.content.body
  })], 2), _c('div', {
    staticClass: "block-header-section__image"
  }, [_vm._t("image", null, {
    "content": _vm.content.image
  })], 2), _c('div', {
    staticClass: "block-header-section__button"
  }, [_vm._t("button", null, {
    "content": _vm.content.button
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf870e5","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-header-section/block-header-section.pug
// module id = 625
// module chunks = 1